"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const grid_styles_1 = require("@/components/common/grid/grid.styles");
let Grid = class Grid extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.columns = 2;
        this.gap = '4';
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
    // 임의 값이라 나열할 수 없고 host가 소비하므로 host에 직접 주입한다.
    willUpdate() {
        if (this.columnMinWidth)
            this.style.setProperty('--_col-min', this.columnMinWidth);
        else
            this.style.removeProperty('--_col-min');
    }
};
Grid.styles = grid_styles_1.gridStyles;
__decorate([
    (0, decorators_js_1.property)({ type: Number, reflect: true })
], Grid.prototype, "columns", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: 'column-min-width' })
], Grid.prototype, "columnMinWidth", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Grid.prototype, "gap", void 0);
Grid = __decorate([
    (0, decorators_js_1.customElement)('mm-grid')
], Grid);
exports.Grid = Grid;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JpZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImdyaWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUEyRDtBQUkzRCxzRUFBaUU7QUFLMUQsSUFBTSxJQUFJLEdBQVYsTUFBTSxJQUFLLFNBQVEsZ0JBQVU7SUFBN0I7O1FBRXNDLFlBQU8sR0FBZ0IsQ0FBQyxDQUFBO1FBRXhCLFFBQUcsR0FBVSxHQUFHLENBQUE7SUFhN0QsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDO0lBRUQsNkNBQTZDO0lBQ25DLFVBQVU7UUFDbEIsSUFBSSxJQUFJLENBQUMsY0FBYztZQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLFlBQVksRUFBRSxJQUFJLENBQUMsY0FBYyxDQUFDLENBQUE7O1lBQzdFLElBQUksQ0FBQyxLQUFLLENBQUMsY0FBYyxDQUFDLFlBQVksQ0FBQyxDQUFBO0lBQzlDLENBQUM7O0FBZk0sV0FBTSxHQUFHLHdCQUFVLENBQUE7QUFDaUI7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7cUNBQXlCO0FBQ3RCO0lBQTVDLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxrQkFBa0IsRUFBRSxDQUFDOzRDQUF3QjtBQUN6QjtJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztpQ0FBaUI7QUFKaEQsSUFBSTtJQURoQixJQUFBLDZCQUFhLEVBQUMsU0FBUyxDQUFDO0dBQ1osSUFBSSxDQWlCaEI7QUFqQlksb0JBQUkifQ==